import { render, staticRenderFns } from "./TableDevolucionRevisar.vue?vue&type=template&id=35861e80&scoped=true"
import script from "./TableDevolucionRevisar.vue?vue&type=script&lang=js"
export * from "./TableDevolucionRevisar.vue?vue&type=script&lang=js"
import style0 from "./TableDevolucionRevisar.vue?vue&type=style&index=0&id=35861e80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35861e80",
  null
  
)

export default component.exports